/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.VendorDropdownFilter2 = (function() {

    /**
     * Namespace VendorDropdownFilter2.
     * @exports VendorDropdownFilter2
     * @namespace
     */
    var VendorDropdownFilter2 = {};

    VendorDropdownFilter2.VendorDropdownFilterModel2 = (function() {

        /**
         * Properties of a VendorDropdownFilterModel2.
         * @memberof VendorDropdownFilter2
         * @interface IVendorDropdownFilterModel2
         * @property {string|null} [id] VendorDropdownFilterModel2 id
         * @property {string|null} [name] VendorDropdownFilterModel2 name
         * @property {number|null} [pageIndex] VendorDropdownFilterModel2 pageIndex
         * @property {number|null} [pageSize] VendorDropdownFilterModel2 pageSize
         */

        /**
         * Constructs a new VendorDropdownFilterModel2.
         * @memberof VendorDropdownFilter2
         * @classdesc Represents a VendorDropdownFilterModel2.
         * @implements IVendorDropdownFilterModel2
         * @constructor
         * @param {VendorDropdownFilter2.IVendorDropdownFilterModel2=} [p] Properties to set
         */
        function VendorDropdownFilterModel2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * VendorDropdownFilterModel2 id.
         * @member {string|null|undefined} id
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        VendorDropdownFilterModel2.prototype.id = null;

        /**
         * VendorDropdownFilterModel2 name.
         * @member {string|null|undefined} name
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        VendorDropdownFilterModel2.prototype.name = null;

        /**
         * VendorDropdownFilterModel2 pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        VendorDropdownFilterModel2.prototype.pageIndex = null;

        /**
         * VendorDropdownFilterModel2 pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        VendorDropdownFilterModel2.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * VendorDropdownFilterModel2 _id.
         * @member {"id"|undefined} _id
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel2.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorDropdownFilterModel2 _name.
         * @member {"name"|undefined} _name
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel2.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorDropdownFilterModel2 _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel2.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorDropdownFilterModel2 _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @instance
         */
        Object.defineProperty(VendorDropdownFilterModel2.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified VendorDropdownFilterModel2 message. Does not implicitly {@link VendorDropdownFilter2.VendorDropdownFilterModel2.verify|verify} messages.
         * @function encode
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @static
         * @param {VendorDropdownFilter2.IVendorDropdownFilterModel2} m VendorDropdownFilterModel2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorDropdownFilterModel2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(10).string(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(24).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(32).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified VendorDropdownFilterModel2 message, length delimited. Does not implicitly {@link VendorDropdownFilter2.VendorDropdownFilterModel2.verify|verify} messages.
         * @function encodeDelimited
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @static
         * @param {VendorDropdownFilter2.IVendorDropdownFilterModel2} message VendorDropdownFilterModel2 message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorDropdownFilterModel2.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VendorDropdownFilterModel2 message from the specified reader or buffer.
         * @function decode
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {VendorDropdownFilter2.VendorDropdownFilterModel2} VendorDropdownFilterModel2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorDropdownFilterModel2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.VendorDropdownFilter2.VendorDropdownFilterModel2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.pageIndex = r.int32();
                    break;
                case 4:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a VendorDropdownFilterModel2 message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof VendorDropdownFilter2.VendorDropdownFilterModel2
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {VendorDropdownFilter2.VendorDropdownFilterModel2} VendorDropdownFilterModel2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorDropdownFilterModel2.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return VendorDropdownFilterModel2;
    })();

    return VendorDropdownFilter2;
})();

module.exports = $root;
